/**
 * Feature flag for the opt-in v2 visual workflow builder.
 *
 * Self-contained so nothing existing is modified. Currently enabled so the
 * opt-in toggle is visible; flip to an environment-driven value before release
 * (default OFF per the design spec).
 */
export const WORKFLOW_BUILDER_V2_ENABLED = true;

export function isWorkflowBuilderV2Enabled(): boolean {
  return WORKFLOW_BUILDER_V2_ENABLED;
}
